import { useEffect } from 'react';

import { Main } from 'app/pages';

import { setUiConfig } from 'app/utils/userSlice';
import { ThemeProvider } from 'app/common/providers';
import { useAlertHook } from 'app/hooks';
import { useAppDispatch, useAppSelector } from 'app/store/store';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorPage } from 'app/pages';
import { useLazyGetSystemConfigurationQuery } from 'app/api/facade';
import { YMInitializer } from 'react-yandex-metrika';
import ym from 'react-yandex-metrika';

const App = () => {
  const { addAlert } = useAlertHook();
  const dispatch = useAppDispatch();

  const [getConfiguration, { data: uiConfiguration }] = useLazyGetSystemConfigurationQuery();

  const auth = useAppSelector((state) => state.userSlice.auth);
  const metrika_accounts = window._env_?.YMETRIKA_ACCOUNTS ? JSON.parse(window._env_.YMETRIKA_ACCOUNTS) : [];

  useEffect(() => {
    if (metrika_accounts && metrika_accounts.length > 0) {
      ym('hit', '/');
    }
  }, [metrika_accounts]);
  useEffect(() => {
    if (auth?.value.loggedIn) {
      getConfiguration()
        .unwrap()
        .catch((error: Error) => addAlert(error));
    }
  }, [auth, addAlert]);

  useEffect(() => {
    if (uiConfiguration?.result) {
      dispatch(setUiConfig(uiConfiguration?.result));
    }
  }, [uiConfiguration]);

  return (
    <ThemeProvider ui={uiConfiguration}>
      <YMInitializer
        accounts={metrika_accounts}
        options={{ webvisor: true, defer: true, clickmap: true, trackLinks: true, accurateTrackBounce: true }}
        version="2"
      />

      <ErrorBoundary fallbackRender={() => <ErrorPage title="ErrorOperationOfService" subtitle="ReloadOrSupport" />} />
      <Main />
    </ThemeProvider>
  );
};

export default App;
